import { render, staticRenderFns } from "./PayableReceivableTable.vue?vue&type=template&id=b6e08dca&scoped=true&"
import script from "./PayableReceivableTable.vue?vue&type=script&lang=js&"
export * from "./PayableReceivableTable.vue?vue&type=script&lang=js&"
import style0 from "./PayableReceivableTable.vue?vue&type=style&index=0&id=b6e08dca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e08dca",
  null
  
)

export default component.exports